import cookies from 'js-cookie';

import { FrontChatInitConfig } from '../types/frontChat';
import { FRONT_CHAT_INIT_CONFIG } from '../constants/frontChat';

export function removeFrontChatInitConfig() {
  cookies.remove(FRONT_CHAT_INIT_CONFIG);
}

export function getFrontChatInitConfig(): FrontChatInitConfig | null {
  try {
    const cookieValue = cookies.get(FRONT_CHAT_INIT_CONFIG);

    return cookieValue
      ? (JSON.parse(cookieValue) as FrontChatInitConfig)
      : null;
  } catch {
    return null;
  }
}

// If the cookie for initialising front chat is set, use it to initialise front chat
// otherwise, use the default config (no user detection)

export async function initFrontChat(): Promise<void> {
  if (typeof window !== 'undefined' && window.FrontChat) {
    const frontChatInitConfig = getFrontChatInitConfig();

    window.FrontChat('init', {
      chatId: process.env.REACT_APP_FRONT_CHAT_ID,
      useDefaultLauncher: true,
      shouldShowWindowOnLaunch: false,
      ...(frontChatInitConfig && frontChatInitConfig),
    });
  }
}
